import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type MatchParticipantModel from 'tio-data/models/match-participant';
import type EmployeeModel from 'tio-data/models/employee';

export interface AuthenticatedSyfRouteModel {
  matchParticipant: MatchParticipantModel;
}

export default class AuthenticatedSyfRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model(): Promise<AuthenticatedSyfRouteModel | null> {
    // Guard the whole lookup: users without an employee record (or whose
    // match-participant includes 403) previously threw out of model(),
    // stranding the transition on /syf with a blank screen. A null model
    // exits the SYF tree (child routes redirect to authenticated.dashboard).
    const employeeId = this.sessionContext.currentEmployee?.id;
    if (!employeeId) {
      return null;
    }

    try {
      const employee = await this.store.findRecord<EmployeeModel>('employee', employeeId, {
        include: [
          'match-participant.email-address',
          'match-participant.match-plan',
          'match-participant.person',
        ].join(','),
        reload: true,
      });

      const matchParticipant = employee.matchParticipant;
      if (!matchParticipant) {
        return null;
      }

      return {
        matchParticipant,
      };
    } catch (e) {
      console.error('Failed to load SYF match participant:', e);
      return null;
    }
  }
}
